import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const SubscriptionSuccess = () => {
    const benefits = [
        {
          title: "Fan Profile Page:",
          message:
            "Showcase your artistry with a personalized fan page.",
        },
        {
          title: "Music Uploads:",
          message:
            "Upload unlimited tracks and manage your growing catalog.",
        },
        {
          title: "Music Fanpage:",
          message:
            "Let your fans stream, like, and share your music directly.",
        },
        {
          title: "Royalties Tracker:",
          message:
            "Get real-time updates on your earnings and withdrawals.",
        },
        {
          title: "Streaming Insights:",
          message:
            "View play counts, fan locations, and top-performing tracks.",
        },
    ].map((benefit)=>(
        <li>
        <span className="text-white font-medium">
         {benefit.title}
        </span>{" "}
        {benefit.message}
      </li>
    ))
    return (
        <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center px-4">
          <div className="max-w-2xl w-full bg-gray-800 rounded-2xl shadow-xl p-8 text-center">
            <div className="flex justify-center mb-6">
              <FontAwesomeIcon
                icon={faCheckCircle}
                size="8x"
                className="text-yellow-500"
              />
            </div>
  
            <h1 className="text-3xl md:text-4xl font-bold text-yellow-500 mb-4">
              Subscription Successful!
            </h1>
  
            <p className="text-gray-300 mb-6 text-lg">
              Thank you for subscribing! You’ve unlocked a world of music features
              designed to elevate your artist experience and connect you directly
              with your fans.
            </p>
  
            <div className="grid gap-4 text-left text-sm text-gray-200 bg-gray-700 p-6 rounded-xl">
              <h2 className="text-yellow-400 text-xl font-semibold mb-2">
                Your Subscription Benefits
              </h2>
  
              <ul className="list-disc list-inside space-y-2">
               {benefits}
              </ul>
            </div>
  
            <div className="mt-8">
              <Link
                to="/user/my-dashboard"
                className="inline-block bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold py-3 px-6 rounded-xl transition-all duration-300">
                Go to Your Dashboard
              </Link>
            </div>
          </div>
        </div>
      );
}
 
export default SubscriptionSuccess;